import { Card } from 'antd'

import Box from '~/core/Box'
import Text from '~/core/Text'
import getColor from '~/lib/getColor'

import Toggle3dAnd2dView from './Toggle3dAnd2dView/Toggle3dAnd2dView'

interface ImDfm3dSlideInfoPropsType {
    topic: string
    message: string
    title: string
    isHighTouch: boolean
    isNonImDfmEnabled: boolean
}

const ImDfm3dSlideInfo = (props: ImDfm3dSlideInfoPropsType) => {
    const { topic, message, title, isHighTouch, isNonImDfmEnabled } = props

    return (
        <Box direction="col" justifyContent="center">
            <Card
                size="small"
                style={{
                    marginBottom: '8px',
                    borderRadius: '4px',
                    border: `1px solid ${getColor('blackAlpha15')}`,
                    width: '100%',
                    padding: '4px',
                }}
            >
                <Text color="blackAlpha65" fontSize="14px" fontWeight={500}>
                    {isHighTouch && isNonImDfmEnabled ? title : topic}
                </Text>
                <Box marginTop="8px">
                    <Text
                        color="blackAlpha65"
                        fontSize="14px"
                        fontWeight={300}
                        style={{
                            marginBottom: '8px',
                        }}
                    >
                        {message}
                    </Text>
                </Box>
                <Toggle3dAnd2dView />
            </Card>
        </Box>
    )
}

export default ImDfm3dSlideInfo
